"use strict";

exports.__esModule = true;
exports.ScheduleList = ScheduleList;
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Core = require("../../Core");
var _CalendarContext = require("../CalendarContext");
var _ScheduleInfo = require("./ScheduleInfo");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ScheduleListWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ScheduleList__ScheduleListWrapper",
  componentId: "sc-hytnaz-0"
})(["overflow-y:auto;"]);
var ScheduleListItem = _styledComponents["default"].div.withConfig({
  displayName: "ScheduleList__ScheduleListItem",
  componentId: "sc-hytnaz-1"
})(["flex:1;margin:1rem;padding:1rem;border-style:solid;border-width:1px;border-color:#a9a9a9;"]);
var hasScheduleEnded = function hasScheduleEnded(_ref) {
  var interval = _ref.interval;
  var now = Date.now();
  return interval.endMillis < now;
};

/**
 * Shows a form which can edit a schedule.
 */
function ScheduleList() {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var _React$useContext2 = _react["default"].useContext(_CalendarContext.CalendarContext),
    calendar = _React$useContext2.calendar;
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  var _useState = (0, _react.useState)(false),
    isHistoricalOpen = _useState[0],
    setIsHistoricalOpen = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    isUpcomingOpen = _useState2[0],
    setIsUpcomingOpen = _useState2[1];
  var activeSchedule;
  var historicalSchedules = [];
  var upcomingSchedules = [];
  calendar.schedules.forEach(function (schedule) {
    if (!hasScheduleEnded(schedule) && !activeSchedule) {
      activeSchedule = schedule;
    } else {
      if (schedule.interval.startMillis > Date.now()) {
        upcomingSchedules.push(schedule);
      } else {
        historicalSchedules.push(schedule);
      }
    }
  });
  historicalSchedules.sort(function (a, b) {
    return b.interval.startMillis - a.interval.startMillis;
  });
  upcomingSchedules.sort(function (a, b) {
    return b.interval.startMillis - a.interval.startMillis;
  });
  return /*#__PURE__*/_react["default"].createElement(ScheduleListWrapper, {
    "data-testid": "ScheduleList"
  }, calendar.schedules.length === 0 && /*#__PURE__*/_react["default"].createElement(_core.NonIdealState, {
    visual: "calendar",
    title: translate("ScheduleList.nonIdealState.title", "No schedules defined"),
    description: translate("ScheduleList.nonIdealState.description", "There are no configured schedules yet"),
    action: /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      to: "/calendar/create-schedule",
      icon: _icons.IconNames.ADD,
      text: translate("Schedule.nonIdealState.action", "Create a new Schedule")
    })
  }), /*#__PURE__*/_react["default"].createElement(ScheduleListItem, {
    key: activeSchedule.id,
    "data-testid": "ScheduleList.ActiveSchedule"
  }, /*#__PURE__*/_react["default"].createElement(_ScheduleInfo.ScheduleInfo, {
    schedule: activeSchedule,
    calendar: calendar,
    isInfoOpen: true,
    isActive: true
  })), upcomingSchedules.length > 0 ? /*#__PURE__*/_react["default"].createElement(ScheduleListItem, null, /*#__PURE__*/_react["default"].createElement(_ScheduleInfo.ScheduleInfoView, null, /*#__PURE__*/_react["default"].createElement(_ScheduleInfo.ScheduleInfoHeader, {
    "data-testid": "ScheduleList.UpcomingSchedules.Header",
    onClick: function onClick() {
      setIsUpcomingOpen(!isUpcomingOpen);
    },
    style: {
      cursor: "pointer"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    icon: isUpcomingOpen ? "chevron-up" : "chevron-down",
    title: isUpcomingOpen ? translate("ScheduleInfo.ScheduleExpandCollapse.collapse", "Collapse") : translate("ScheduleInfo.ScheduleExpandCollapse.expand", "Expand"),
    size: 48,
    color: theme && theme.color ? theme.color : "defaultColor"
  }), /*#__PURE__*/_react["default"].createElement(_ScheduleInfo.ScheduleInfoTitle, null, translate("ScheduleList.UpcomingSchedules.title", "Upcoming Schedules")))), isUpcomingOpen && upcomingSchedules.map(function (schedule) {
    return /*#__PURE__*/_react["default"].createElement(ScheduleListItem, {
      key: schedule.id
    }, /*#__PURE__*/_react["default"].createElement(_ScheduleInfo.ScheduleInfo, {
      schedule: schedule,
      calendar: calendar
    }));
  })) : null, historicalSchedules.length > 0 ? /*#__PURE__*/_react["default"].createElement(ScheduleListItem, null, /*#__PURE__*/_react["default"].createElement(_ScheduleInfo.ScheduleInfoView, null, /*#__PURE__*/_react["default"].createElement(_ScheduleInfo.ScheduleInfoHeader, {
    "data-testid": "ScheduleList.HistoricalSchedules.Header",
    onClick: function onClick() {
      setIsHistoricalOpen(!isHistoricalOpen);
    },
    style: {
      cursor: "pointer"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    icon: isHistoricalOpen ? "chevron-up" : "chevron-down",
    title: isHistoricalOpen ? translate("ScheduleInfo.ScheduleExpandCollapse.collapse", "Collapse") : translate("ScheduleInfo.ScheduleExpandCollapse.expand", "Expand"),
    size: 48,
    color: theme && theme.color ? theme.color : "defaultColor"
  }), /*#__PURE__*/_react["default"].createElement(_ScheduleInfo.ScheduleInfoTitle, null, translate("ScheduleList.InactiveSchedules.title", "Inactive Schedules")))), isHistoricalOpen && historicalSchedules.map(function (schedule) {
    return /*#__PURE__*/_react["default"].createElement(ScheduleListItem, {
      key: schedule.id
    }, /*#__PURE__*/_react["default"].createElement(_ScheduleInfo.ScheduleInfo, {
      schedule: schedule,
      calendar: calendar
    }));
  })) : null);
}